import { Inertia } from '@inertiajs/inertia'
import Grid from '@mui/material/Grid'
import Pagination from '@mui/material/Pagination'

const PaginationNotTable = ({ nameRoute, filter, setPaging, paging, pageNumber }) => {
  const handleChangePage = (event, value) => {
    setPaging(value)
    let check = {}
    filter.map((row) => {
      if (row.value && 'available_codes_operator' !== row.name && 1 !== row.value) {
        check = { ...check, [row.name]: row.value }
      }
    })
    Inertia.get(route(nameRoute, { ...check, page: value }))
  }
  return (
    <Grid container justifyContent="center" pb={2} pt={2}>
      <Pagination
        showFirstButton
        showLastButton
        color="primary"
        count={pageNumber}
        page={paging[0]?.page}
        onChange={handleChangePage}
      />
    </Grid>
  )
}

export default PaginationNotTable
